import { PlusIcon } from "@heroicons/react/outline";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  addMetersStepsState,
  addMeterState,
  meterCompaniesListState,
} from "../atoms/atoms";

import { ValidateMeter } from "../../../../../domain/usecases";
// import ValidateMeterFail from "../components/addMeterFail";
import AddMeterList from "../components/addMetersList";

import { Validation } from "../../../../protocols";
import { useEffect, useState } from "react";
import Input from "../components/input";
import { query, collection, onSnapshot, where } from "firebase/firestore";
import { db } from "../../../../../main/firebase";
import { makeAddMeterDetails } from "../../../../../main/factories/pages/meters/add/add-meter-details-factory";
import { makeAddMeterStepsButton } from "../../../../../main/factories/pages/meters/add/add-meter-steps-button-factory";
import { ReactComponent as Spinner } from "../../../../assets/spinner.svg";
import { currentAccountState } from "../../../../components";
import FormStatus from "../components/form-status";

type Props = {
  validateMeter: ValidateMeter;
  validation: Validation;
};

export default function AddMeters({ validateMeter, validation }: Props) {
  const { getCurrentAccount } = useRecoilValue(currentAccountState);
  const setMetersStepsState = useSetRecoilState(addMetersStepsState);
  const [state, setState] = useRecoilState(addMeterState);
  const setCompaniesList = useSetRecoilState(meterCompaniesListState);

  const [showError, setshowError] = useState(false);

  useEffect(() => validate("meterNumber"), [state.meterNumber]);
  useEffect(() => resetStepsState(), []);

  const resetStepsState = () => {
    const resetState = [
      {
        number: 1,
        name: "Add Meters",
        description: "Add meters to recharge.",
        href: "#",
        status: "current",
      },
      {
        number: 2,
        name: "Submit for approval",
        description: "Submit for approval.",
        href: "#",
        status: "upcoming",
      },
    ];

    setMetersStepsState(resetState);
  };

  const validate = (field: string): void => {
    const { meterNumber } = state;
    const formData = { meterNumber };
    // if (submitForm) {
    setState((old) => ({
      ...old,
      [`${field}Error`]: validation.validate(field, formData),
    }));

    setState((old) => ({ ...old, isFormInvalid: !!old.meterNumberError }));
    // }
  };

  useEffect(() => {
    const q = query(
      collection(db, "companies"),
      where("account", "==", getCurrentAccount().account)
    );
    return onSnapshot(q, (querySnapshot) => {
      let result = querySnapshot.docs.map((doc) => {
        return {
          account: doc.data().account,
          createdBy: doc.data().createdBy,
          dateCreated: doc.data().dateCreated,
          isActive: doc.data().isActive,
          name: doc.data().name,
          companyNumber: doc.data().companyNumber,
          postalAddress: doc.data().postalAddress,
          city: doc.data().city,
          phoneNumber: doc.data().phoneNumber,
        };
      });
      setCompaniesList((old) => ({ ...old, companiesList: result }));
      // setState((old) => ({ ...old, companiesList: result }));
    });
  }, []);

  const handleSubmit = async (
    event: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    event.preventDefault();

    try {
      if (state.isLoading || state.isFormInvalid) {
        setshowError(true);
        return;
      }

      setState((old) => ({ ...old, mainError: "", isLoading: true }));

      const isMeterInAddList = state.metersToAdd.find(
        (m) => m.meterNumber === state.meterNumber
      );

      if (isMeterInAddList) {
        // state.mainError();
        setState((old) => ({
          ...old,
          isLoading: false,
          mainError: "The supplied meter is already in list.",
        }));

        return;
      }

      let { currentValidatedMeter } = state;

      const validatedMeter = await validateMeter.validate({
        account: getCurrentAccount().account,
        meterNumber: state.meterNumber,
      });

      if (validatedMeter) {
        console.log("validatedMeter", validatedMeter);
        currentValidatedMeter = validatedMeter!;
      } else {
        console.log("validatedMeter fail", validatedMeter);
        setState({
          ...state,
          validateMeterFailed: true,
        });
      }

      setState({
        ...state,
        validateMeterFailed: false,

        currentValidatedMeter: currentValidatedMeter,
      });

      setState((old) => ({
        ...old,
        isLoading: false,
        meterNumber: "",
        mainError: "",
      }));
      setshowError(false);
      return;

      // setCurrentAccount(account)
      // history.replace('/')
    } catch (error) {
      setState((old) => ({
        ...old,
        validateMeterFailed: true,
      }));

      setState((old) => ({
        ...old,
        isLoading: false,
        mainError: error.message,
      }));
    }
  };

  return (
    <>
      {!state.currentValidatedMeter && (
        <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-12">
          <div className="sm:col-span-12">
            <form onSubmit={(e) => handleSubmit(e)} className="flex">
              <div className="flex flex-col">
                <label htmlFor="meter" className="sr-only">
                  Meter Number
                </label>
                <Input
                  type="number"
                  name="meterNumber"
                  className="block border border-gray-200 placeholder-gray-300 font-medium rounded-sm py-2 mr-4 border-b border-transparent bg-white focus:border-blue-600 focus:ring-0 sm:text-sm"
                  placeholder="BPC Meter"
                />
                {showError && (
                  <div className=" block text-sm text-red-500">
                    {state.meterNumberError}
                  </div>
                )}
              </div>
              <div>
                <button
                  type="submit"
                  className="relative inline-flex justify-center py-2 px-6 border border-transparent rounded-sm shadow-sm disabled:opacity-50 text-sm font-medium  text-white bg-blue-600 hover:bg-blue-700  active:bg-indingo-800 focus:outline-none "
                  disabled={state.isLoading}
                >
                  {state.isLoading ? (
                    <>
                      <Spinner className=" h-5" /> Validating Meter...
                    </>
                  ) : (
                    <>
                      <PlusIcon
                        className="-ml-1 mr-2 h-5 w-5 text-white"
                        aria-hidden="true"
                      />
                      Validate BPC Meter
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {makeAddMeterDetails()}
      {/* <ValidateMeterFail /> */}
      <FormStatus />
      <AddMeterList />

      {state.metersToAdd.length > 0 &&
        state.currentValidatedMeter === null &&
        makeAddMeterStepsButton({
          step: "initiate",
          isEnabled:
            state.metersToAdd.length > 0 &&
            state.currentValidatedMeter === null,
          primaryText: "Submit Meters",
          secondaryText: "Clear All",
        })}
    </>
  );
}
